module.exports = __webpack_public_path__ + "img/GE.a48e9919.svg";